import request from '@api/request'

const BASE_URL = '/lishui-qym-ent'
// 新增诉求
export const addAppeal = params =>
  request.post(BASE_URL + '/entAppeal/addAppeal', params)

// 诉求详情
export const appealDetail = params =>
  request.get(BASE_URL + '/entAppeal/appealDetail', {
    params
  })

// 企业评价
export const entEvaluate = params =>
  request.post(BASE_URL + '/entAppeal/entEvaluate', params)

// 新增诉求
export const appealList = params =>
  request.get(BASE_URL + '/entAppeal/appealList', { params })

// 修改诉求 /entAppeal/editAppral
export const editAppral = data =>
  request.post(BASE_URL + '/entAppeal/editAppral', data)

// 用户信息
export const userInfo = params =>
  request.get(BASE_URL + '/entAppeal/userInfo', { params })

// 企业端获取区县列表
export const getArea = params =>
  request.get(BASE_URL + '/entAppeal/getArea', { params })
